export default __webpack_public_path__ + "static/media/trading.0fb3b696.png";